import {assign} from 'lodash';

export default function ReportingService(Restangular, ApiRestangular, StorageService, UrlService) {
  'ngInject';
  let resourceUrl = `${process.env.__backendUrl__}/api/reporting/v2/reports`;
  
  let service = Restangular.service(resourceUrl);

  service.deviceReportUrl = function(params) {
    // does it even make sense to use restangular
    // (or should we just use raw strings)
    // let url = service.one('device-report').getRestangularUrl();
    let url = `${process.env.__backendUrl__}/api/reporting/v2/reports/device-report`
    let outUrl = UrlService.generateWithJWT(url, params);

    return outUrl;
  };

  service.managingOrgDeviceReport = (params) => {
    let url = service.one('managing-org-device-report').getRestangularUrl();
    return UrlService.generateWithJWT(url, params);
  };

  service.getDeviceReportsByManagingOrgPage = function(params) {
    if (params && params.managingOrgId !== undefined) {
      let url = this.makeDeviceReportsByManagingOrgPageUrl(params.managingOrgId, params.page);
      return Restangular.oneUrl('reporting', url).get();
    }
  };

  service.makeDeviceReportsByManagingOrgPageUrl = function(managingOrgId, page) {
    return `${resourceUrl}?managingOrgId=${managingOrgId}&page=${page}`;
  };

  service.generateManagingOrgDisplayReport = (data) => {
    return Restangular.oneUrl('reporting', `${process.env.__backendUrl__}/api/reporting/v2/reports`).customPOST(data, '', {}, {});
  }

  service.isCompleted = function(report) {
    return report.state == 'COMPLETED';
  };

  service.downloadUrl = function(report) {
    if (service.isCompleted(report)) {
      let url = `${resourceUrl}/${report.id}/download`;
      url += '?JWT=' + StorageService.get('idToken');  // TODO: use SessionsService.
      return url;
    }
  };

  return service;
}
